module.exports = __webpack_public_path__ + "static/media/facebookRound.82ad41f2.svg";